import { makeObservable } from 'mobx';
import { CommonService } from './common';

export class OutstandingService extends CommonService {
  constructor() {
    super();
    makeObservable(this);
  }
}
